import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { fetchPublicMaintenance, adminSaveMaintenance } from '../../services/site';
import { Button } from '../ui/button';
import { Wrench, Power } from 'lucide-react';

const AdminMaintenanceBadge = () => {
  const { token, user } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const isFounder = !!user && (user.user_type === 'fondateur' || user.type === 'admin');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetchPublicMaintenance();
        setEnabled(!!res?.enabled);
      } catch (e) {}
    };
    load();
    const id = setInterval(load, 15000);
    return () => clearInterval(id);
  }, []);

  if (!isFounder || !enabled) return null;

  const disable = async () => {
    if (!token) return;
    setLoading(true);
    try {
      await adminSaveMaintenance({ enabled: false }, token);
      setEnabled(false);
    } catch (e) {
      // no-op
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed bottom-4 left-4 z-50" data-testid="maintenance-badge">
      <div className="flex items-center gap-2 bg-destructive text-destructive-foreground px-3 py-2 rounded-md shadow-lg border border-destructive/40">
        <Wrench className="w-4 h-4" />
        <span className="text-sm font-medium">Maintenance active</span>
        <Button size="sm" variant="secondary" className="h-7 px-2" onClick={disable} disabled={loading}>
          <Power className="w-4 h-4 mr-1" />
          {loading ? '...' : 'Désactiver'}
        </Button>
      </div>
    </div>
  );
};

export default AdminMaintenanceBadge;